import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxBoxModule, DxButtonModule } from 'devextreme-angular';
import { HttpService } from '../../../http.service';
import { ActionType, MerchantStatus } from '../../home/models';
import { RichFormModule } from '../../../components/library/rich-form/rich-form.component';
import { FormGroup } from '@angular/forms';
import { FormPopupModule } from '../../../components/library/form-popup/form-popup.component';
import notify from 'devextreme/ui/notify';

@Component({
  standalone: true,
  imports: [
    DxBoxModule,
    DxButtonModule,
    CommonModule,
    RichFormModule,
    FormPopupModule
  ],
  selector: 'app-request-additional-info',
  templateUrl: './request-additional-info.component.html',
  styleUrl: './request-additional-info.component.scss'
})
export class RequestAdditionalInfoComponent {
  @Input() isRequestAdditionalInfoPopupOpened: boolean = false;
  @Input() merchantId: number = 0;
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();

  formUiWidgets!: Record<string, any>[];
  data: Record<string, any> = {
    additionalInfo: ''
  }
  isLoading = false;
  isContentScrolled = false;
  dataForm!: FormGroup;

  constructor(private httpService: HttpService) {
  }

  ngOnInit(): void {
    this.formUiWidgets = this.getFormControls();
  }

  onRequestAdditioanlInfoClick(e: any) {
    this.isRequestAdditionalInfoPopupOpened = true;
  }

  onConfirmRequestAdditionalInfoClick(e: any) {
    let model = new MerchantStatus(this.merchantId, ActionType.RequestAdditionalInformation, this.data['additionalInfo']);
    this.httpService.changeMerchantStatus(model).subscribe(res => {
      notify({
        message: 'Merchant additional request is send!',
        position: {
          my: 'center top',
          at: 'center top',
        },
      }, 'success', 3000);
    });
  }

  getFormControls() {
    return [
      {
        label: 'Explicit notes to the client',
        dataField: 'additionalInfo',
        colSpan: 1,
        width: '150px',
        height: '80px',
        FormType: 'RequestAddionalInformation'
      },
    ]
  }

  scroll({ reachedTop = false }) {
    this.isContentScrolled = !reachedTop;
  }

  dataChanged(object) {
    //set populated form field 
    if ('event' in object) {
      this.dataForm.patchValue({
        [object.event.dataField]: object.event.value
      });
    }

    this.notifyContainerDataChanged.emit(object);
  }
}
